module.exports = __webpack_public_path__ + "static/img/xlh.b1abc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xlh.png
// module id = KyWg
// module chunks = 128